export default __webpack_public_path__ + "static/media/necesarias.3e26ac5e.png";